// extracted by mini-css-extract-plugin
export var compactFilters = "_e7-4";
export var detailImage = "_e7-1";
export var dropdownContainer = "_e7-2";
export var imageContainer = "_e7-0";
export var selectedCard = "_e7-3";